// chatgpt-helper.js

async function askFelinaAI(prompt) {
  try {
    const response = await fetch("https://openai-proxy-mu-pearl.vercel.app/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        messages: [
          { role: "system", content: "Eres un experto en marketing, redacción creativa y diseño para tiendas Shopify." },
          { role: "user", content: prompt }
        ]
      })
    });

    const data = await response.json();
    console.log("🧠 Respuesta IA:", data.choices?.[0]?.message?.content);
    return data.choices?.[0]?.message?.content || "No se obtuvo respuesta de la IA.";
  } catch (error) {
    console.error("❌ Error al conectar con la IA:", error);
  }
}

// 💡 Prueba rápida (desde consola del navegador)
// askFelinaAI("Dame una descripción para una colección de relojes modernos.")
